var map = {
	"./BAAC.png": 58441,
	"./BAY.png": 99707,
	"./BBL.png": 52024,
	"./CIMB.png": 84882,
	"./CITI.png": 77765,
	"./DB.png": 68601,
	"./GHB.png": 51231,
	"./GSB.png": 91750,
	"./HSBC.png": 33245,
	"./IDR/BCA SYARIAH.png": 40614,
	"./IDR/BCA.png": 5165,
	"./IDR/BJB.png": 80118,
	"./IDR/BNI SYARIAH.png": 34499,
	"./IDR/BNI.png": 87263,
	"./IDR/BRI SYARIAH.png": 10114,
	"./IDR/BRI.png": 2904,
	"./IDR/BSI.png": 61820,
	"./IDR/BTN.png": 93781,
	"./IDR/BTPN.png": 30284,
	"./IDR/CIMB.png": 33,
	"./IDR/DANA.png": 48904,
	"./IDR/DANAMON.png": 92772,
	"./IDR/GOPAY.png": 96803,
	"./IDR/JATIM.png": 68260,
	"./IDR/MANDIRI SYARIAH.png": 26081,
	"./IDR/MANDIRI.png": 52366,
	"./IDR/MAYBANK.png": 62851,
	"./IDR/NOBU.png": 15607,
	"./IDR/OVO.png": 48894,
	"./IDR/PERMATA.png": 83115,
	"./IDR/SHOPEEPAY.png": 74438,
	"./IDR/SINARMAS.png": 78216,
	"./ISBT.png": 15781,
	"./KBANK.png": 55473,
	"./KK.png": 44862,
	"./KTB.png": 53076,
	"./LHBANK.png": 72910,
	"./MHCB.png": 53286,
	"./SCB.png": 92870,
	"./SCBT.png": 71260,
	"./SMBC.png": 62101,
	"./TBANK.png": 80473,
	"./TCRB.png": 28341,
	"./TISCO.png": 30229,
	"./TMB.png": 15486,
	"./TTB.png": 5437,
	"./UOBT.png": 38269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67938;